import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";
import { ReactElement } from "react";

export default function Error500Svg({
    sx,
    ...rest
}: SvgIconProps): ReactElement {
    const theme = useTheme();
    const color = theme.palette.primary.main;
    return (
        <SvgIcon
            viewBox="0 0 233 232"
            sx={{ width: 233, height: 232, ...sx }}
            {...rest}
        >
            <path
                d="M116.444 232C180.509 232 232.444 180.065 232.444 116C232.444 51.935 180.509 0 116.444 0C52.3793 0 0.444336 51.935 0.444336 116C0.444336 180.065 52.3793 232 116.444 232Z"
                fill="url(#paint0_linear_23981_6397)"
                fillOpacity="0.5"
            />
            <path
                d="M163.947 159.674V193.366C163.947 196.061 161.754 198.307 158.956 198.307H70.9984C68.2757 198.307 66.0068 196.136 66.0068 193.366V159.674C66.0068 156.979 68.2001 154.732 70.9984 154.732H159.032C161.754 154.732 163.947 156.904 163.947 159.674Z"
                fill="url(#paint1_linear_23981_6397)"
            />
            <path
                d="M80.6014 166.338C82.0214 166.338 83.1725 165.198 83.1725 163.792C83.1725 162.386 82.0214 161.247 80.6014 161.247C79.1814 161.247 78.0303 162.386 78.0303 163.792C78.0303 165.198 79.1814 166.338 80.6014 166.338Z"
                fill="#273D7A"
            />
            <path
                d="M89.6766 166.338C91.0966 166.338 92.2477 165.198 92.2477 163.792C92.2477 162.386 91.0966 161.247 89.6766 161.247C88.2566 161.247 87.1055 162.386 87.1055 163.792C87.1055 165.198 88.2566 166.338 89.6766 166.338Z"
                fill="white"
            />
            <path
                d="M98.828 166.338C100.248 166.338 101.399 165.198 101.399 163.792C101.399 162.386 100.248 161.247 98.828 161.247C97.408 161.247 96.2568 162.386 96.2568 163.792C96.2568 165.198 97.408 166.338 98.828 166.338Z"
                fill="white"
            />
            <path
                d="M150.181 177.044H127.719C126.736 177.044 125.904 176.221 125.904 175.248C125.904 174.274 126.736 173.451 127.719 173.451H150.181C151.165 173.451 151.997 174.274 151.997 175.248C151.997 176.221 151.165 177.044 150.181 177.044Z"
                fill="white"
            />
            <path
                d="M150.635 178.991C152.723 178.991 154.416 177.315 154.416 175.247C154.416 173.18 152.723 171.504 150.635 171.504C148.546 171.504 146.854 173.18 146.854 175.247C146.854 177.315 148.546 178.991 150.635 178.991Z"
                fill={color}
            />
            <path
                d="M118.568 198.008H77.501L79.0136 194.339C79.7699 192.467 81.585 191.27 83.627 191.27H112.518C114.56 191.27 116.299 192.467 117.131 194.339L118.568 198.008Z"
                fill="white"
            />
            <path
                d="M153.357 198.007H78.0293V203.323H153.357V198.007Z"
                fill="#E6E0DF"
            />
            <path
                d="M163.947 120.367V144.026C163.947 146.721 161.754 148.967 158.956 148.967H70.9984C68.2757 148.967 66.0068 146.796 66.0068 144.026V120.367C66.0068 117.671 68.2001 115.425 70.9984 115.425H159.032C161.754 115.425 163.947 117.671 163.947 120.367Z"
                fill="url(#paint2_linear_23981_6397)"
            />
            <path
                d="M80.6014 127.105C82.0214 127.105 83.1725 125.965 83.1725 124.559C83.1725 123.153 82.0214 122.014 80.6014 122.014C79.1814 122.014 78.0303 123.153 78.0303 124.559C78.0303 125.965 79.1814 127.105 80.6014 127.105Z"
                fill="white"
            />
            <path
                d="M89.6766 127.105C91.0966 127.105 92.2477 125.965 92.2477 124.559C92.2477 123.153 91.0966 122.014 89.6766 122.014C88.2566 122.014 87.1055 123.153 87.1055 124.559C87.1055 125.965 88.2566 127.105 89.6766 127.105Z"
                fill="white"
            />
            <path
                d="M98.828 127.105C100.248 127.105 101.399 125.965 101.399 124.559C101.399 123.153 100.248 122.014 98.828 122.014C97.408 122.014 96.2568 123.153 96.2568 124.559C96.2568 125.965 97.408 127.105 98.828 127.105Z"
                fill="#273D7A"
            />
            <path
                d="M150.181 130.624H127.719C126.736 130.624 125.904 129.8 125.904 128.827C125.904 127.853 126.736 127.03 127.719 127.03H150.181C151.165 127.03 151.997 127.853 151.997 128.827C151.997 129.8 151.165 130.624 150.181 130.624Z"
                fill="white"
            />
            <path
                d="M150.635 132.57C152.723 132.57 154.416 130.894 154.416 128.827C154.416 126.759 152.723 125.083 150.635 125.083C148.546 125.083 146.854 126.759 146.854 128.827C146.854 130.894 148.546 132.57 150.635 132.57Z"
                fill={color}
            />
            <path
                d="M118.568 148.592H77.501L79.0136 144.923C79.7699 143.051 81.585 141.854 83.627 141.854H112.518C114.56 141.854 116.299 143.051 117.131 144.923L118.568 148.592Z"
                fill="white"
            />
            <path
                d="M153.357 148.592H78.0293V154.357H153.357V148.592Z"
                fill="#E6E0DF"
            />
            <rect
                width="16.2561"
                height="16.2561"
                transform="matrix(0.710663 0.703533 -0.710663 0.703533 136.436 99.0083)"
                fill="#FB0200"
            />
            <mask
                id="mask0_23981_6397"
                maskUnits="userSpaceOnUse"
                x="127"
                y="101"
                width="18"
                height="18"
            >
                <rect
                    x="144.773"
                    y="118.699"
                    width="17.0492"
                    height="16.8781"
                    transform="rotate(180 144.773 118.699)"
                    fill="#D9D9D9"
                />
            </mask>
            <g mask="url(#mask0_23981_6397)">
                <path
                    d="M136.248 113.776C136.639 113.776 136.973 113.914 137.252 114.19C137.53 114.465 137.669 114.796 137.669 115.183C137.669 115.57 137.53 115.901 137.252 116.176C136.973 116.452 136.639 116.589 136.248 116.589C135.858 116.589 135.523 116.452 135.245 116.176C134.967 115.901 134.828 115.57 134.828 115.183C134.828 114.796 134.967 114.465 135.245 114.19C135.523 113.914 135.858 113.776 136.248 113.776ZM137.314 103.931L137.314 112.37L135.183 112.37L135.183 103.931L137.314 103.931Z"
                    fill="white"
                />
            </g>
            <path
                d="M75.0379 99.3231C70.3232 99.3231 66.2659 99.0284 62.8659 98.4391C59.4659 97.8044 57.0859 97.1924 55.7259 96.6031L57.0859 88.6471V86.6071C58.0379 87.3324 59.3525 88.1031 61.0299 88.9191C62.7072 89.7351 64.6339 90.4377 66.8099 91.0271C69.0312 91.5711 71.3659 91.8431 73.8139 91.8431C77.0325 91.8431 79.1632 91.2537 80.2059 90.0751C81.2939 88.8964 81.8379 87.4004 81.8379 85.5871C81.8379 83.7284 81.2259 82.3004 80.0019 81.3031C78.8232 80.2604 76.5112 79.7391 73.0659 79.7391C69.4845 79.7391 66.4019 79.8977 63.8179 80.2151C61.2792 80.4871 59.4885 80.7817 58.4459 81.0991V57.8431H88.5019V59.8831L89.8619 66.6831C89.3632 66.3657 88.0032 66.0711 85.7819 65.7991C83.5605 65.4817 80.4325 65.3231 76.3979 65.3231H68.7819V70.4231C68.7819 71.4204 68.8952 72.0097 69.1219 72.1911C69.3485 72.3724 70.1419 72.4631 71.5019 72.4631H76.3979C81.6565 72.4631 85.6005 73.5511 88.2299 75.7271C90.8592 77.9031 92.1739 81.2577 92.1739 85.7911C92.1739 89.9164 90.7912 93.2031 88.0259 95.6511C85.3059 98.0991 80.9765 99.3231 75.0379 99.3231ZM115.648 99.3231C109.619 99.3231 105.108 97.5324 102.116 93.9511C99.1242 90.3244 97.6282 85.0204 97.6282 78.0391C97.6282 71.2391 99.1469 66.0711 102.184 62.5351C105.222 58.9537 109.71 57.1631 115.648 57.1631H116.396C122.244 57.1631 126.642 58.9311 129.588 62.4671C132.58 66.0031 134.076 71.1937 134.076 78.0391C134.076 85.0204 132.58 90.3244 129.588 93.9511C126.642 97.5324 122.244 99.3231 116.396 99.3231H115.648ZM115.648 91.7751H116.396C117.938 91.7751 119.252 91.3897 120.34 90.6191C121.428 89.8031 122.267 88.3977 122.856 86.4031C123.446 84.4084 123.74 81.6204 123.74 78.0391C123.74 74.5484 123.446 71.8511 122.856 69.9471C122.267 67.9977 121.428 66.6377 120.34 65.8671C119.252 65.0511 117.938 64.6431 116.396 64.6431H115.648C114.107 64.6431 112.747 65.0284 111.568 65.7991C110.435 66.5697 109.551 67.9297 108.916 69.8791C108.282 71.7831 107.964 74.5031 107.964 78.0391C107.964 81.6657 108.282 84.4764 108.916 86.4711C109.551 88.4657 110.435 89.8484 111.568 90.6191C112.747 91.3897 114.107 91.7751 115.648 91.7751ZM157.551 99.3231C151.521 99.3231 147.011 97.5324 144.019 93.9511C141.027 90.3244 139.531 85.0204 139.531 78.0391C139.531 71.2391 141.049 66.0711 144.087 62.5351C147.124 58.9537 151.612 57.1631 157.551 57.1631H158.299C164.147 57.1631 168.544 58.9311 171.491 62.4671C174.483 66.0031 175.979 71.1937 175.979 78.0391C175.979 85.0204 174.483 90.3244 171.491 93.9511C168.544 97.5324 164.147 99.3231 158.299 99.3231H157.551ZM157.551 91.7751H158.299C159.84 91.7751 161.155 91.3897 162.243 90.6191C163.331 89.8031 164.169 88.3977 164.759 86.4031C165.348 84.4084 165.643 81.6204 165.643 78.0391C165.643 74.5484 165.348 71.8511 164.759 69.9471C164.169 67.9977 163.331 66.6377 162.243 65.8671C161.155 65.0511 159.84 64.6431 158.299 64.6431H157.551C156.009 64.6431 154.649 65.0284 153.471 65.7991C152.337 66.5697 151.453 67.9297 150.819 69.8791C150.184 71.7831 149.867 74.5031 149.867 78.0391C149.867 81.6657 150.184 84.4764 150.819 86.4711C151.453 88.4657 152.337 89.8484 153.471 90.6191C154.649 91.3897 156.009 91.7751 157.551 91.7751Z"
                fill="url(#paint3_linear_23981_6397)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_23981_6397"
                    x1="116.444"
                    y1="-3.40593e-08"
                    x2="115.873"
                    y2="168.571"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} stopOpacity="0.5" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_23981_6397"
                    x1="114.637"
                    y1="132.945"
                    x2="114.97"
                    y2="198.307"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} />
                    <stop offset="1" stopColor="#9BBCFF" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_23981_6397"
                    x1="114.637"
                    y1="107.489"
                    x2="114.97"
                    y2="148.968"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} />
                    <stop offset="1" stopColor="#9BBCFF" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_23981_6397"
                    x1="116.013"
                    y1="35.6431"
                    x2="116.013"
                    y2="99.0082"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} />
                    <stop offset="1" stopColor="#C0D5FF" />
                </linearGradient>
            </defs>
        </SvgIcon>
    );
}
